import { BaseClient } from '@/common/services/api/BaseClient'

export class TariffsApi extends BaseClient {
  getTariffs = this.createRequest({
    url: '/api/public/billing/products',
    method: 'get',
  })
  getUserPayer = this.createRequest({
    url: '/api/billing/payer',
    method: 'get',
  })
  getUserPublicPayer = this.createRequest({
    url: '/api/public/billing/payer',
    method: 'get',
  })
  updateSubscription = this.createRequest({
    url: '/api/billing/subscription/update',
    method: 'post',
  })
  makePay = this.createRequest({
    url: '/api/billing/payment/create',
    method: 'post',
  })
  sendAnalytic = this.createRequest({
    url: '/api/public/track-url-transitions',
    method: 'post',
  })
  createEnterprise = this.createRequest({
    url: '/api/public/billing/payment/enterprise/create',
    method: 'post',
  })
  getPaymentMethods = this.createRequest({
    url: '/api/billing/methods',
    method: 'get',
  })

  getPaymentMethod = ({ id, token }) => {
    return this.createRequest({
      url: `/api/billing/payments/${id}`,
      method: 'get',
      token,
    })()
  }

  sendPromocode = (promocode) => {
    return this.createRequest({
      url: `/api/billing/promocode/check?code=${promocode}`,
      method: 'get',
    })()
  }
}
